import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../environments/environment';
import {CompanyCountdown, Countdown} from '../models/countdown';

const API = environment.API;

@Injectable({
  providedIn: 'root'
})
export class CountdownService {

  constructor(private http: HttpClient) {
  }

  getByMembershipId(membershipId: string) {
    return this.http.get<Countdown>(`${API}/api/countdowns/membership/${membershipId}`);
  }

  getByPlace(placeId: string) {
    return this.http.get<Countdown>(`${API}/api/countdowns/place/${placeId}`);
  }

  getByUserIdAndPlace(userId: string, placeId: string) {
    const params = {placeId};
    return this.http.get<Countdown>(`${API}/api/countdowns/user/${userId}`, {params});
  }

  getByUserId(userId: string) {
    return this.http.get<Countdown>(`${API}/api/countdowns/user/${userId}`);
  }

  getBaseRemainingByMembershipCode(membershipCode: string) {
    return this.http.get<Countdown>(`${API}/api/countdowns/base/${membershipCode}/membershipCode`);
  }

  getBaseRemainingByMembershipId(membershipId: string) {
    return this.http.get<Countdown>(`${API}/api/countdowns/base/${membershipId}/membershipId`);
  }

  getByCompanyId(companyId: string) {
    return this.http.get<Countdown>(`${API}/api/countdowns/company/${companyId}`);
  }

  findByCompanyId(companyId: string) {
    return this.http.get<CompanyCountdown[]>(`${API}/api/countdowns/company/${companyId}/all`);
  }

}
